import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarSimpleRightSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconSidebarSimpleRightSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M15 4.5V19.5H4.75C4.61193 19.5 4.5 19.3881 4.5 19.25V4.75C4.5 4.61193 4.61193 4.5 4.75 4.5H15ZM21 4.75C21 3.7835 20.2165 3 19.25 3H4.75C3.7835 3 3 3.7835 3 4.75V19.25C3 20.2165 3.7835 21 4.75 21H19.25C20.2165 21 21 20.2165 21 19.25V4.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarSimpleRightSquare;
